import { z } from "zod";

export const SiteAccessManagerSchema = z
  .object({
    id: z.string(),
    projectId: z.string(),
    userId: z.string(),
    name: z.string(),
    email: z.string().email().nullable(),
  })
  .strict();

export type SiteAccessManager = z.infer<typeof SiteAccessManagerSchema>;
